import { FC, FormEvent, useEffect, useState } from "react";
import ReactCreditCard, { Focused } from 'react-credit-cards';
import { PaymentModel } from "../../payment/models";
import 'react-credit-cards/es/styles-compiled.css';
import { AlertView, AlertModel } from '../../../../_template/helpers/components/AlertList'
import { BinInstallmentModel } from "../../payment/models/BinInstallmentModel";
import { ReCaptchaButton } from "../../../../_template/layout/core/ReCaptchaButton";
import clsx from "clsx";
import CreditCardInput from "../../payment/components/widget/CreditCardInput";
import ExpireDateInput from "../../payment/components/widget/ExpireDateInput";
import CurrencyInput, { CurrencyInputOnChangeValues } from "react-currency-input-field";
import queryString from 'query-string'
import { useLocation } from "react-router-dom";
import { LinkPaymentModel } from "../../linkpayment/models";
import { getInstallment, linkPaymentGet, linkPaymentPay } from "../redux/LinkPaymentPayCrud";
import { useIntl } from 'react-intl';
import CurrencyFormat from "react-currency-format";
import * as Yup from "yup";



export const LinkPaymentPay: FC = () => {
    let focus: Focused = "name";
    const placeholders = { name: "KART SAHİBİ", valid: "SKT" }
    const defaultInputFields = {
        card_cvv: "",
        card_expire_year: "",
        card_expire_month: "",
        focus: focus,
        card_owner_name: "",
        card_number: "",
        payment_type: 1,
        return_url: '/payment/result',
        save_card: 0
    }

    const intl = useIntl();
    const { search } = useLocation()
    const queryStringParams = queryString.parse(search)

    const [linkPaymentDetail, setLinkPaymentDetail] = useState<LinkPaymentModel | null>(null);
    const pymntToken = queryStringParams.token?.toString();

    const [inputFields, setInputFields] = useState<PaymentModel>(defaultInputFields);
    const [cardFocus, setCardFocus] = useState<Focused>("name");
    const [error, setError] = useState('');
    const [alerts, setAlerts] = useState<AlertModel[]>([])
    const [installmentInfo, setInstallmentInfo] = useState<BinInstallmentModel>()
    const [selectedInstallment, setSelectedInstallment] = useState(0)
    const [loading, setLoading] = useState(false);
    const [errors, setPaymentValicationErros] = useState<any>({})
    const [submitting, setSubmitting] = useState(true);
    const [cardBin, setCardBin] = useState('')


    const validationSchema = Yup.object().shape({
        amount: Yup.number().required("Zorunlu Alan").min(1, "Hatalı Giriş"),
        installment: Yup.number().required("Uygun Taksit Bulunamadı").min(1, "Uygun Taksit Bulunamadı"),
        card_owner_name: Yup.string().required("Zorunlu Alan"),
        card_number: Yup.string().required("Zorunlu Alan").matches(RegExp('^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$'), "Geçersiz Kart Numarası"),
        card_expire_year: Yup.number().required("Zorunlu Alan").min((new Date()).getFullYear() - 2000, "Hatalı Giriş"),
        card_expire_month: Yup.number().required("Zorunlu Alan").min(1, "Hatalı Giriş").max(12, "Hatalı Giriş"),
        card_cvv: Yup.string().required("Zorunlu Alan")
    })

    const fetchLinkPayment = async () => {
        try {
            if (pymntToken && !linkPaymentDetail) {
                const response = await linkPaymentGet(pymntToken);
                setLinkPaymentDetail(response.data?.data || null);
                setInputFields({ ...inputFields, amount: response.data?.data.amount });
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    };

    useEffect(() => {
        fetchLinkPayment();
    }, [pymntToken]);

    useEffect(() => {
        setInputFields({ ...inputFields, installment: selectedInstallment });
    }, [selectedInstallment])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputFields({ ...inputFields, [e.target.name]: e.target.value });
    };
    const cardNumberHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputFields({ ...inputFields, [e.target.name]: e.target.value.replace(/\D/g, '') });
        if (cardBin !== e.target.value.replace(/\D/g, '').substring(0, 8) && e.target.value.replace(/\D/g, '').substring(0, 8).length > 5) {
            setCardBin(e.target.value.replace(/\D/g, ''));
        }
    };
    const expireDateHandleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const dates = e.target.value.split('/');
        setInputFields({ ...inputFields, card_expire_month: dates[0], card_expire_year: (dates[1] ?? "") });
    };
    const amountHandleChange = (value: string | undefined, name?: string, values?: CurrencyInputOnChangeValues) => {
        if (values && values.float) {
            setInputFields({ ...inputFields, amount: values.float });
        } else {
            setInputFields({ ...inputFields, amount: undefined });
        }
    };

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case "card_owner_name": setCardFocus("name"); break;
            case "expire_date": setCardFocus("expiry"); break;
            case "card_number": setCardFocus("number"); break;
            case "card_cvv": setCardFocus("cvc"); break;
        }
    }

    const showAlert = (alert: AlertModel) => {
        setAlerts((prevToasts) => [...prevToasts, alert])
    }

    const getInstallmentOptions = (bin: string, amount: number) => {
        if (amount < 1) return;
        if (!pymntToken) return;
        setSelectedInstallment(0);
        setLoading(true);
        setSubmitting(true);
        getInstallment(pymntToken, { bin: bin, amount: amount })
            .then(({ data }) => {
                if (!data.status) {
                    showAlert({ title: intl.formatMessage({ id: 'GENERAL.ERROR' }), state: "danger", description: intl.formatMessage({ id: data.errors?.join() ?? "" }) })
                } else {
                    setInstallmentInfo(data.data);
                    setSelectedInstallment(1);
                    setSubmitting(false);
                }
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                setError("Sistem Hatası");
            });
    }

    useEffect(() => {
        if (!cardBin) return;
        const timeOutId = setTimeout(() => getInstallmentOptions(cardBin, inputFields.amount ?? 0), 1000);
        return () => clearTimeout(timeOutId);
    }, [cardBin, inputFields.amount]);

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        validationSchema.validate(inputFields, { abortEarly: false })
            .catch(e => {
                let errList = {}
                e.inner.forEach(function (err: any) {
                    errList = { ...errList, [err.path]: err.message }
                });
                setPaymentValicationErros(errList);
            });

        if (validationSchema.isValidSync(inputFields)) {
            doPayment3D();
        }
        return false;
    }

    const doPayment3D = () => {
        if (!pymntToken) return;
        setLoading(true);
        setSubmitting(true);
        linkPaymentPay(pymntToken, inputFields)
            .then(({ data }) => {
                if (!data.status) {
                    showAlert({ title: intl.formatMessage({ id: 'GENERAL.ERROR' }), state: "danger", description: intl.formatMessage({ id: data.errors?.join() ?? "" }) })
                    setSubmitting(false);
                } else {
                    window.location.href = data.data;
                }
            })
            .catch((error) => {
                setLoading(false);
                setError("Sistem Hatası");
                setSubmitting(false);
            })
            .finally(() => {
                setLoading(false)
            });
    }


    return (
        <>
            {!linkPaymentDetail ? <></> :
                (linkPaymentDetail && linkPaymentDetail.status != 1) ?
                    <>
                        <div className="mb-lg-15 alert alert-danger">
                            <div className="alert-text font-weight-bold">
                                Link ödeme pasif durumdadır. Lütfen yeni bir link talep ediniz.
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <AlertView alerts={alerts} />

                        <div className="form w-100">
                            {error ? (
                                <div className="mb-lg-15 alert alert-danger">
                                    <div className="alert-text font-weight-bold">
                                        {error}
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}{" "}

                            <ReactCreditCard
                                cvc={inputFields.card_cvv!}
                                expiry={`${inputFields.card_expire_month}/${inputFields.card_expire_year}`}
                                focused={cardFocus}
                                name={inputFields.card_owner_name!}
                                number={inputFields.card_number!}
                                placeholders={placeholders}
                                locale={placeholders}
                            />
                            <div className='fv-row mt-10 mb-10 text-start'>
                                <label className='form-label fs-6 fw-bolder text-dark'>Kart Sahibi</label>
                                <input
                                    placeholder='Kart Sahibi'
                                    onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}
                                    className={clsx('form-control form-control-lg', { "is-invalid": errors.card_owner_name })}
                                    type='text'
                                    name='card_owner_name'
                                    autoComplete='off'
                                    onChange={handleChange}
                                    onFocus={handleFocus}
                                />
                                {errors.card_owner_name && (
                                    <div className="fv-plugins-message-container invalid-feedback">
                                        <span role="alert">
                                            {errors.card_owner_name}
                                        </span>
                                    </div>
                                )}
                            </div>
                            <div className='fv-row mb-10 text-start'>
                                <label className='form-label fs-6 fw-bolder text-dark'>Kart Numarası</label>
                                <CreditCardInput formHandleChange={cardNumberHandleChange} inputName='card_number' errorMessage={errors.card_number} onFocus={handleFocus} />
                            </div>
                            <div className='fv-row mb-10 text-start'>
                                <label className='form-label fs-6 fw-bolder text-dark'>Son Kullanma Tarihi (AA/YY)</label>
                                <ExpireDateInput formHandleChange={expireDateHandleChange} inputName='expire_date' errorMessage={
                                    errors.card_expire_month ? errors.card_expire_month : errors.card_expire_year ? errors.card_expire_year : undefined
                                } onFocus={handleFocus} />
                            </div>
                            <div className='fv-row mt-10 mb-10 text-start'>
                                <label className='form-label fs-6 fw-bolder text-dark'>Güvenlik Numarası(CVV)</label>

                                <input
                                    placeholder='Güvenlik Numarası(CVV)'
                                    onKeyDown={e => { e.key === 'Enter' && e.preventDefault() }}
                                    className={clsx('form-control form-control-lg', { "is-invalid": errors.card_cvv })}
                                    type='text'
                                    name='card_cvv'
                                    autoComplete='off'
                                    onChange={handleChange}
                                    onFocus={handleFocus} />
                                {errors.card_cvv && (
                                    <div className="fv-plugins-message-container invalid-feedback">
                                        <span role="alert">
                                            {errors.card_cvv}
                                        </span>
                                    </div>
                                )}
                            </div>

                            <div className='fv-row mt-10 mb-10 text-start'>
                                <label className='form-label fs-6 fw-bolder text-dark'>Tutar</label>

                                {
                                    (linkPaymentDetail?.amount ?? 0) == 0 ?
                                        <>
                                            <CurrencyInput
                                                name="amount"
                                                placeholder=""
                                                decimalsLimit={2}
                                                onValueChange={amountHandleChange}
                                                decimalSeparator=","
                                                groupSeparator="."
                                                className={clsx("form-control form-control-lg", { "is-invalid": errors.amount })}
                                                autoComplete="off"
                                                suffix={linkPaymentDetail?.currency}
                                            />
                                        </>
                                        :
                                        <>
                                            <CurrencyInput
                                                name="amount"
                                                placeholder=""
                                                decimalsLimit={2}
                                                decimalSeparator=","
                                                groupSeparator="."
                                                className={clsx("form-control form-control-lg", { "is-invalid": errors.amount })}
                                                autoComplete="off"
                                                suffix={linkPaymentDetail?.currency}
                                                value={linkPaymentDetail?.amount}
                                            />
                                        </>
                                }

                                {errors.amount && (
                                    <div className="fv-plugins-message-container invalid-feedback">
                                        <span role="alert">
                                            {errors.amount}
                                        </span>
                                    </div>
                                )}
                            </div>


                            <hr />

                            <div className='fv-row mt-10 mb-10 text-start '>
                                <label className="form-label fs-6 fw-bolder text-dark">
                                    Taksit Seçenekleri
                                </label>
                                <div className={clsx('container border', { "is-invalid": errors.installment })} >
                                    <div className="row mb-2 " style={{ marginRight: "-26px", marginLeft: "-25px" }} >
                                        <div className="col border">Taksit Seçin</div>
                                        <div className="col border">Tutar</div>
                                        <div className="col border">Aylık Ödeme</div>
                                        <div className="col border">Toplam Ödeme</div>
                                    </div>
                                    {!installmentInfo && (
                                        <div className='row'>
                                            <div className="col">
                                                Taksit seçenekleri kart bilginizi ve tutarı girdikten sonra görünecektir.
                                            </div>
                                        </div>
                                    )}
                                    {installmentInfo && !installmentInfo.installments && (
                                        <div className='row'>
                                            <div className="col-24 ">
                                                Kart bilgilerinize ait taksit seçeneği bulunamadı. Lütfen kart numaranızı kontrol ediniz.
                                            </div>
                                        </div>
                                    )}
                                    {installmentInfo && installmentInfo.installments && (
                                        installmentInfo.installments.map((intst) => {
                                            return (
                                                <div className='row mb-2' key={`installment-${intst.installment_cnt}`}>
                                                    <div className='col border form-check form-check-sm form-check-custom'>
                                                        <input className="form-check-input" type="radio" value="" id={`installment-checked-${intst.installment_cnt}`} checked={selectedInstallment == intst.installment_cnt} onChange={e => { setSelectedInstallment(intst.installment_cnt); setInputFields({ ...inputFields, installment: intst.installment_cnt }); }} />
                                                        <label className="form-check-label" htmlFor={`installment-checked-${intst.installment_cnt}`}>
                                                            {
                                                                intst.installment_cnt == 1 ? ("Tek Çekim") : (`${intst.installment_cnt} Taksit`)
                                                            }
                                                        </label>
                                                    </div>
                                                    <div className='col border text-end'>
                                                        <CurrencyFormat value={inputFields.amount} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={2} fixedDecimalScale={true} suffix={installmentInfo.currency} />
                                                    </div>
                                                    <div className='col border text-end'>
                                                        <CurrencyFormat value={intst.installment_price} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={2} fixedDecimalScale={true} suffix={installmentInfo.currency} />
                                                    </div>
                                                    <div className='col border text-end'>
                                                        <CurrencyFormat value={intst.total_price} displayType={'text'} thousandSeparator='.' decimalSeparator=',' decimalScale={2} fixedDecimalScale={true} suffix={installmentInfo.currency} />
                                                    </div>
                                                </div>
                                            )
                                        })
                                    )}
                                </div>
                                {errors.installment && (
                                    <div className="fv-plugins-message-container invalid-feedback">
                                        <span role="alert">
                                            {errors.installment}
                                        </span>
                                    </div>
                                )}
                            </div>

                            <hr />
                            <form onSubmit={handleSubmit}>
                                <div className="text-center">
                                    <ReCaptchaButton
                                        id="paymnet_page"
                                        className="btn btn-success btn-sm w-100"
                                        disabled={
                                            submitting
                                        }
                                        loading={loading}
                                        spanClassName="indicator-label"
                                        text="ÖDEME YAP"
                                        actionName="LINK_PAYMENT"
                                    />
                                </div>
                            </form>
                        </div>
                    </>
            }
        </>
    )
}